import { createRouter, createWebHistory } from 'vue-router'

const routes = [{
  path: '/',
  name: 'About',
  component: () =>
    import('../views/About')
},
{
  path: '/projects',
  name: 'Projects',
  component: () =>
    import('../views/Projects')
},
{
  path: '/contact',
  name: 'Contact',
  component: () => import('../views/Contact')
},
{
  path: '/cv',
  name: 'CV',
  beforeEnter () {
    location.href = 'https://drive.google.com/file/d/1oYrJxHgXdm0e6o3ZlzWlqq2yETGApEd0/view?usp=sharing'
  }
},
{
  path: '/*',
  name: 'Redirect',
  redirect: '/'
}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, SavedPosition) {
    if (to.hash) {
      const el = window.location.href.split('#')[1]
      if (el.length) {
        document.getElementById(el).scrollIntoView({ behavior: 'smooth' })
      }
    } else if (SavedPosition) {
      return SavedPosition
    } else {
      document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
    }
  }
})

export default router
